import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { useTranslation } from "@/lib/i18n/i18n";

export default function NotFound() {
  const t = useTranslation();
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4 sm:px-6" role="alert" aria-live="assertive">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2 items-center">
            <AlertCircle className="h-7 w-7 sm:h-8 sm:w-8 text-red-500 shrink-0" aria-hidden="true" />
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100">{t("common.notFound404.title")}</h1>
          </div>

          <p className="mt-4 text-sm text-gray-600 dark:text-gray-300">
            {t("common.notFound404.message")}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
